module.exports = __webpack_public_path__ + "static/media/Bettdecke_100x135_Kissen_80x80.b64081cc.png";